import { MDXComponents } from "mdx/types";

import { Separator } from "@/components/ui/separator";
import {
  H1,
  H2,
  H3,
  H4,
  ListItem,
  OrderedList,
  P,
  UnorderedList,
} from "@/components/ui/typography";

export const mdxComponents = {
  h1: (props) => <H1 {...props} className="mb-8" />,
  h2: H2,
  h3: H3,
  h4: H4,
  p: (props) => <P {...props} className="my-4" />,
  ul: UnorderedList,
  ol: OrderedList,
  li: ListItem,
  hr: Separator,
} satisfies MDXComponents;
